$(document).ready(function () {
    $('.edit-profile-btn').click(function(){
        event.preventDefault();               

        $('.edit-profile .required').each(inputCheck);

        var address = $('#address'),
            parent  = address.parent(); 

        if(!mapPlaceholder){
            parent.addClass('error');
            parent.find('.error-message').remove();
            parent.append('<p class="error-message">выберите точку</p>');
        }else if(address.val() == ''){
            parent.addClass('error');
            parent.find('.error-message').remove();
            parent.append('<p class="error-message">заполните поле</p>');
        }else{
            parent.removeClass('error');
        } 

        if($('.error').length == 0){
            loader_on();

            var additional_phone = $('#additional-phone').val();

            if( additional_phone.indexOf('_') > 0 ){
                additional_phone = '';
            }else{
                for( var i = 0; i < 10; i++){
                    var check = additional_phone.split(i).length - 1;
                    if(check > 6){
                        additional_phone = '';
                    }
                }
            }

            var name              = $('#name').val(),
                surname           = $('#surname').val(),
                email             = $('#email').val(),
                phone             = $('#phone').val(),
                address           = $('#address').val(),
                coords            = mapPlaceholder.geometry.getCoordinates(),
                notice            = $('.edit-profile .form-notice'),
                result            = {
                    'name'             : name,
                    'surname'          : surname,
                    'email'            : email,
                    'phone'            : phone,
                    'additional_phone' : additional_phone,
                    'address'          : address,
                    'coords'           : coords
                };            

            
            sendAjax('edit_profile', result, 
                function(res){
                    loader_off();
                    showNotice(notice, 'Успех', 'Ваши данные были успешно сохранены.');
                },
                function(res){
                    loader_off();
                    showNotice(notice, 'Ошибка', 'Что-то пошло не так.', 0);
                }
            );
            
        }else{
            var offset = $('.edit-profile .error').eq(0).offset().top - 80;
            $('html, body').animate({ 
                scrollTop: offset
            }, 400); 
        }
    })
});